import "core-js/modules/es.array.push.js";
import Bus from '@/assets/js/bus.js';
import axios from 'axios';
import { mapState } from 'vuex';
import i18n from '@/lang/index.js';
const CancelToken = axios.CancelToken;
export default {
  props: {
    receiverNicknames: String,
    partyCode: [String, Number],
    shareRtilCode: [String, Number],
    partyInfo: Object,
    nickNameInfo: Object,
    shareList: Object,
    currentTypeShare: String,
    mainWindowList: Array,
    pageNum: [String, Number],
    globalControlId: [String],
    showTitle: {
      type: Boolean,
      default: true
    },
    rtilCodeList: {
      type: Array,
      default: function () {
        return [];
      }
    },
    globalOutputTimestamp: [String, Number],
    partyOutputTimestamp: [String, Number]
  },
  data() {
    return {
      showTag: false,
      nickName: '',
      enableTag: false,
      sourceTypeTag: '',
      input: '',
      getReceiverParams: {
        pageNum: 1,
        pageSize: 10,
        living: true,
        offline: false,
        online: true,
        condition: ''
      },
      Url: '',
      // showSelect: false,
      coHostReceiverNickname: '',
      receiverNickname: '',
      Username: '',
      UserVfbname: '',
      encoderInfo: {
        visible: false,
        data: [],
        maxNumber: 1
      },
      selectOutputType: '',
      selectOutput: '',
      mainwindowId: '',
      mainwindowType: '',
      changeSourceLabel: {
        Participant: 'pip',
        Default: 'VFB',
        'SDI #1': 'VFB',
        'SDI #2': 'VFB',
        PGM: 'PP',
        Pbp: 'PBP',
        Tag: 'Tag',
        shareScreen: 'shareScreen',
        // setoutput的时候 推送的sourcetype是小写
        ShareScreen: 'shareScreen' // join的时候 推送的sourcetype是大写
      },

      outputList: [],
      pipList: [],
      sourceVfbType: {
        show: false
      },
      liveLoading: false,
      sendReceiverInfo: {},
      mainwindowPBP: [],
      pbpList: [{
        position: 1,
        text: 'selectLeftSource',
        rtilCode: '',
        outputList: []
      }, {
        position: 2,
        text: 'selectRightSource',
        rtilCode: '',
        outputList: []
      }],
      changeSourceParams: {
        VFB: 'Receiver',
        PP: 'Producer',
        pip: 'Participant',
        PBP: 'Pbp',
        shareScreen: 'ShareScreen',
        Tag: 'Tag'
      },
      requestUrl: {
        send: {
          party: '/partyline-backend/commonParty/startPushStream',
          kiosk: '/partyline-backend/kiosk/v2/startPushStream',
          group: '/partyline-backend/group/v2/startPushStream',
          coordinator: '/partyline-backend/conference/startPushStream',
          globalControl: '/partyline-backend/globalControl/startPushStream'
        },
        stop: {
          party: '/partyline-backend/commonParty/stopPushStream',
          kiosk: '/partyline-backend/kiosk/v2/stopPushStream',
          group: '/partyline-backend/group/v2/stopPushStream',
          coordinator: '/partyline-backend/conference/stopPushStream',
          globalControl: '/partyline-backend/globalControl/stopPushStream'
        }
      },
      showPreviewBox: false,
      globalMainInfo: {},
      listScroll: {
        distance: 15,
        directive: '.selectBox .el-scrollbar__wrap',
        onScroll: this.loadNextPage
      },
      receiverListInfo: {},
      cancel: {}
    };
  },
  computed: {
    ...mapState({
      State: state => state,
      ChannelMode: state => state.channelMode
    }),
    shareListCode() {
      let array = [];
      if (this.selectOutputType == 'shareScreen') {
        array = Object.keys(this.shareList).map(shareCode => {
          return {
            mainwindowId: parseInt(shareCode)
          };
        });
      }
      return array;
    },
    sendBtnColor() {
      let color = 'gray';
      if (this.selectOutputType == 'PBP') {
        const mainwindowPBPIds = this.mainwindowPBP.map(v => v.rtilCode);
        this.pbpList.forEach(val => {
          if (val.rtilCode) {
            color = 'green';
          }
          if (mainwindowPBPIds !== null && mainwindowPBPIds !== void 0 && mainwindowPBPIds.includes(val.rtilCode)) {
            color = 'red';
          }
        });
      } else {
        if (!this.selectOutput && this.selectOutputType != 'Tag') {
          color = 'gray';
        }
        if (this.selectOutput || this.selectOutputType == 'Tag' && this.enableTag == false) {
          color = 'green';
        }
        // 为了 Gallery view 在单独添加一种判断
        if (this.selectOutput && this.selectOutput == this.mainwindowId || this.selectOutput && this.selectOutput == this.nickName || this.selectOutput && this.selectOutput == this.coHostReceiverNickname && this.selectOutputType != 'Tag' || this.selectOutput && this.$route.name === 'group' && this.selectOutputType === 'shareScreen' || this.State.isTag == 1 && this.selectOutputType == 'Tag') {
          color = 'red';
        }
      }
      return color;
    },
    showSelectBox() {
      if (this.$route.name === 'group' && this.selectOutput && this.selectOutputType === 'shareScreen') {
        return true;
      }
      return false;
    },
    returnClass() {
      return this.$route.name === 'party' && this.selectOutputType === 'PP' ? 'partyMode' : '';
    },
    returnPlaceholder() {
      let placeholder = '';
      if (this.selectOutputType === 'Tag') {
        placeholder = this.$t('kioskHost.tagInput');
      } else {
        placeholder = this.$t('kioskHost.selectSource');
      }
      return placeholder;
    },
    returnNoData() {
      let noData = '';
      if (this.selectOutputType === 'PP') {
        noData = this.$t('common.noProgram');
      } else {
        noData = this.$t('common.noMainWinDowData');
      }
      return noData;
    }
  },
  filters: {
    showSourceType(value) {
      if (value === 'Source type') {
        return i18n.t('kioskHost.sourceType');
      } else if (value === 'VFB (Receiver Video Return)') {
        return i18n.t('kioskHost.vfbSource');
      } else if (value === 'PP (Producer)') {
        return i18n.t('kioskHost.ppSource');
      } else if (value === 'Shared Screen') {
        return i18n.t('kioskHost.shareSource');
      } else if (value === 'Participant') {
        return i18n.t('kioskHost.pipOne');
      } else if (value === 'PBP (2x Participants)') {
        return i18n.t('kioskHost.pbpTwo');
      } else if (value === 'pip') {
        return i18n.t('kioskHost.pip');
      } else if (value === 'Broadcaster (Participants)') {
        return i18n.t('kioskHost.broadCasterPip');
      } else if (value === 'Speaker (Participants)') {
        return i18n.t('kioskHost.speakerPip');
      } else if (value === 'Tag') {
        return i18n.t('kioskHost.Tag');
      } else {
        return value;
      }
    }
  },
  watch: {
    shareListCode: function (val) {
      if (this.selectOutputType == 'shareScreen') {
        this.outputList = val;
      }
    },
    mainwindowType: function (val) {
      let btn = false;
      this.mainWindowList.forEach(v => {
        v.options.forEach((value, index) => {
          if (val == 'PBP') {
            if (value.value == 'shareScreen') {
              v.options.splice(index, 1);
            }
          } else {
            if (value.value == 'shareScreen') {
              btn = true;
            }
          }
        });
        // Conference 页面不需要分享
        if (!btn && val != 'PBP' && this.$route.name != 'newCoordinator' && this.$route.name != 'coordinator' && this.$route.name != 'globalControl') {
          v.options.push({
            value: 'shareScreen',
            label: 'Shared Screen'
          });
        }
      });
    },
    shareList: function (val) {
      if (!val[this.selectOutput] && this.selectOutputType == 'shareScreen') {
        this.selectOutput = '';
      }
    },
    selectOutputType: {
      immediate: true,
      handler: function (val) {
        if (val === 'Broadcaster') {
          const array = [];
          let codeList = [];
          codeList = JSON.parse(JSON.stringify(this.rtilCodeList));
          codeList = codeList.filter(rtilcode => {
            return rtilcode > 0;
          });
          codeList.forEach(rtilCode => {
            const type = this.State.deviceTypeMap[rtilCode];
            if (this.nickNameInfo[rtilCode] && type != 'T' && type != 'R' && type != 'Anywhere' && type != 'App') {
              const obj = {};
              obj.mainwindowId = rtilCode;
              array.push(obj);
            }
          });
          this.outputList = array;
        }
      }
    }
  },
  created() {
    Bus.$emit('initMainWindowType', this.selectOutputType);
    Bus.$on('viewPosition2', result => {
      let rtilCodes = result.total || [];
      // 同步更新piplist
      rtilCodes = rtilCodes.filter(v => v != this.shareRtilCode && this.nickNameInfo[v]);
      this.pipList = rtilCodes.map(code => {
        return {
          mainwindowId: code,
          nickName: this.nickNameInfo[code]
        };
      });
      if (this.selectOutputType == 'pip' || this.selectOutputType == 'PBP') {
        this.outputList = this.pipList;
      }
      if (this.selectOutputType == 'pip' || this.selectOutputType == 'PBP' || this.selectOutputType == 'shareScreen') {
        var _rtilCodes;
        // 是否清空当前选项的值
        if (!((_rtilCodes = rtilCodes) !== null && _rtilCodes !== void 0 && _rtilCodes.includes(this.selectOutput)) && this.selectOutput != this.mainwindowId) {
          this.selectOutput = '';
        }
      }
    });
    Bus.$on('setSpeaker', v => {
      let flag = true;
      this.outputList.forEach(item => {
        item.rtilCode == v.rtilCode ? flag = false : '';
      });
      if (flag) {
        this.outputList.push({
          mainwindowId: v.rtilCode,
          nickName: v.nickName,
          rtilCode: v.rtilCode
        });
      }
    });
    Bus.$on('setOutput', v => {
      if (this.$route.name == 'globalControl' && v.sourceType == 'Participant') return;
      if (this.selectOutputType != 'Tag') {
        this.globalMainInfo = {};
      }
      const _this = this;
      if (v.sourceType == 'Pbp') {
        this.mainwindowPBP = v.pbpInfo.pbpSources;
        const mainwindowPBPIds = this.mainwindowPBP.map(v => v.rtilCode).filter(v => v);
        this.pbpList.forEach(val => {
          if (!(mainwindowPBPIds !== null && mainwindowPBPIds !== void 0 && mainwindowPBPIds.includes(val.rtilCode))) {
            this.$set(val, 'rtilCode', '');
          }
        });
      } else {
        this.mainwindowId = v.receiverId || v.rtilCode;
        if (this.$route.name === 'group' && v.sourceType === 'ShareScreen') {
          this.selectOutput = 'Host(me)';
        } else {
          if (this.State.currentPartyInfo.coHost != 2 && this.State.currentPartyInfo.coHost != 1 || v.sourceType == 'ShareScreen') {
            this.selectOutput = this.mainwindowId;
            // 用来处理cohost和host流的名称不一致的变量
            this.coHostReceiverNickname = v.receiverNickname;
            if (v.rtilCode == _this.State.partyTag) {
              this.selectOutput = v.nickName;
              this.nickName = v.nickName;
            }
          } else {
            if (v.sourceType != 'Participant') {
              this.selectOutput = v.receiverNickname;
            }
            this.coHostReceiverNickname = v.receiverNickname;
          }
        }
      }
      // 因为 Gallery 的 broadcaster 和 Kiosk 的 pip 类型都是 participant 所以要先判断是哪个页面
      const routeName = this.$route.name;
      if (v.sourceType === 'Participant' && routeName === 'group') {
        this.mainwindowType = 'Broadcaster';
      } else {
        // 为了下拉框中可以选择 slot 添加的判断逻辑
        if (v.outputType === 'Producer') {
          this.selectOutputType = 'PP';
        } else {
          this.mainwindowType = this.changeSourceLabel[v.sourceType];
        }
      }
      if (this.mainwindowType) {
        this.selectOutputType = this.mainwindowType;
      }
    });
    Bus.$on('cancelOutput', v => {
      if (this.partyInfo.status) {
        this.partyInfo.status.outputSource = '';
        this.partyInfo.status.outputId = '';
        this.partyInfo.status.output = '';
      }
      this.selectOutput = '';
      this.mainwindowId = '';
      this.mainwindowType = '';
      this.mainwindowPBP = [];
      if (v.rtilCode == this.selectOutput) {
        this.selectOutput = '';
      }
      if (v.sourceType == 'Pbp') {
        this.pbpList.forEach(val => {
          var _v$rtilCodes;
          if ((_v$rtilCodes = v.rtilCodes) !== null && _v$rtilCodes !== void 0 && _v$rtilCodes.includes(val.rtilCode)) {
            this.$set(val, 'rtilCode', '');
          }
        });
      }
    });
    Bus.$on('endParty', () => {
      this.sendReceiverInfo = {};
      this.partyInfo.status.outputSource = '';
      this.partyInfo.status.output = '';
      this.partyInfo.status.outputId = '';
    });
    // 为了 kiosk GlobalControl 添加的
    Bus.$on('startPushStreamFromGlobalControl', v => {
      // if (this.$route.name != 'globalControl') return
      const {
        outputId,
        outputSource,
        output,
        receiverNickname,
        sourceType,
        enable
      } = v;
      if (this.$route.name == 'globalControl') {
        this.sourceTypeTag = sourceType;
        if (v.sourceType == 'Tag') {
          this.enableTag = enable;
          this.State.isTag = 1;
        }
      }
      if (this.$route.name != 'globalControl') this.globalMainInfo = v;
      this.mainwindowId = outputId || output;
      if (this.$route.name == 'kiosk' && outputSource === 'PGM') {
        this.selectOutput = receiverNickname;
        this.nickName = receiverNickname;
      } else {
        this.selectOutput = outputId || receiverNickname;
      }
      this.mainwindowType = this.changeSourceLabel[outputSource];
      if (this.mainwindowType) {
        this.selectOutputType = this.mainwindowType;
      }
    });
    Bus.$on('stopPushStreamFromGlobalControl', v => {
      if (this.$route.name == 'globalControl') {
        this.sourceTypeTag = v.sourceType;
        if (v.sourceType == 'Tag') {
          this.enableTag = v.enable;
          this.State.isTag = 0;
        }
      }
      if (this.globalOutputTimestamp > this.partyOutputTimestamp || this.$route.name == 'globalControl') {
        this.partyInfo.outputSource = '';
        this.partyInfo.outputId = '';
        this.partyInfo.output = '';
        this.globalMainInfo = {};
        this.selectOutput = '';
        this.mainwindowId = '';
        this.mainwindowType = '';
      }
    });
    Bus.$on('addToGlobalControl', v => {
      const {
        output,
        outputId,
        outputSource,
        receiverNickname
      } = v.mainWindowOutputParam;
      this.globalMainInfo = v;
      this.mainwindowId = outputId || output;
      this.selectOutput = outputId || receiverNickname;
      this.mainwindowType = this.changeSourceLabel[outputSource];
      if (this.mainwindowType) {
        this.selectOutputType = this.mainwindowType;
      }
    });
    Bus.$on('removeFromGlobalControl', () => {
      if (this.$route.name === 'globalControl') return;
      this.partyInfo.outputSource = '';
      this.partyInfo.outputId = '';
      this.partyInfo.output = '';
      this.globalMainInfo = {};
      this.selectOutput = '';
      this.mainwindowId = '';
      this.mainwindowType = '';
    });
    Bus.$on('applyStreamForAll', v => {
      if (v.enable == true) return;
      const {
        output,
        outputId,
        outputSource,
        receiverNickname
      } = v;
      if (this.$route.name != 'globalControl') this.globalMainInfo = v;
      this.mainwindowId = outputId || output;
      if (this.$route.name == 'kiosk' && outputSource === 'PGM') {
        this.selectOutput = receiverNickname;
        this.nickName = receiverNickname;
      } else {
        this.selectOutput = outputId || receiverNickname;
      }
      this.mainwindowType = this.changeSourceLabel[outputSource];
      if (this.mainwindowType) {
        this.selectOutputType = this.mainwindowType;
      }
    });
    Bus.$on('setDefault', () => {
      this.setDefault();
    });
    // 如果有 fullscreen 代表是 globalControl 的 partyInfo需要特殊处理
    const {
      status
    } = this.partyInfo;
    if (this.$route.name === 'globalControl') {
      const {
        outputId,
        outputSource,
        tag
      } = this.partyInfo;
      if (tag == 1) {
        this.selectOutputType = 'Tag';
      } else {
        this.selectOutputType = this.changeSourceLabel[outputSource];
      } // share根据rtilCOde查询memberId，状态准确
      if ((!outputSource || outputSource !== null && outputSource !== void 0 && outputSource.includes('SDI')) && tag != 1) {
        this.selectOutputType = 'VFB';
      }
      this.selectOutput = outputId;
      if (this.selectOutputType == 'PBP') {
        // 存在多个mainwindow
        this.mainwindowPBP = status.multiOutput.pbpSources;
        this.pbpList.forEach(val => {
          this.mainwindowPBP.forEach(item => {
            if (val.position == item.position) {
              this.$set(val, 'rtilCode', item.rtilCode);
            }
          });
        });
      }
      this.mainwindowId = this.selectOutput;
      this.mainwindowType = this.changeSourceLabel[outputSource];
    } else {
      var _outputSource;
      let outputSource = '';
      if (this.partyInfo.globalControl && this.partyInfo.globalControl.outputId && this.partyInfo.globalControl.outputTimestamp > status.outputTimestamp) {
        outputSource = this.partyInfo.globalControl.outputSource;
      } else {
        status ? outputSource = status.outputSource : '';
      }
      // UI 统一所以需要单独为 Gallery view 页面添加判断
      const routeName = this.$route.name;
      if (routeName === 'group' && status.outputSource === 'Participant') {
        this.selectOutputType = 'Broadcaster';
      } else {
        // 为了下拉框中可以选择 slot 添加的判断逻辑
        if (status.outputType === 'Producer') {
          this.selectOutputType = 'PP';
        } else {
          this.selectOutputType = this.changeSourceLabel[outputSource] || 'VFB'; // share根据rtilCOde查询memberId，状态准确
        }
      }

      if (status && (!outputSource || (_outputSource = outputSource) !== null && _outputSource !== void 0 && _outputSource.includes('SDI'))) {
        this.selectOutputType = 'VFB';
      }
      if (this.selectOutputType == 'PBP') {
        // 存在多个mainwindow
        this.mainwindowPBP = status.multiOutput.pbpSources;
        this.pbpList.forEach(val => {
          this.mainwindowPBP.forEach(item => {
            if (val.position == item.position) {
              this.$set(val, 'rtilCode', item.rtilCode);
            }
          });
        });
      } else {
        if (status && this.State.currentPartyInfo.coHost != 2 && this.State.currentPartyInfo.coHost != 1) {
          // 为了 Global Control 添加
          if (this.partyInfo.globalControl && this.partyInfo.globalControl.outputId && this.partyInfo.globalControl.outputTimestamp > status.outputTimestamp) {
            this.selectOutput = this.partyInfo.globalControl.outputId;
            this.mainwindowId = this.selectOutput;
            this.globalMainInfo = this.partyInfo.globalControl;
          } else {
            this.selectOutput = status.outputId || status.output;
            this.mainwindowId = this.selectOutput;
          }
        } else {
          this.selectOutput = this.receiverNicknames;
          this.mainwindowId = this.selectOutput;
        }
      }
      this.mainwindowType = this.changeSourceLabel[outputSource];
    }
    this.getOutputList('getReceiverList');
  },
  methods: {
    updateTagStage() {
      this.enableTag = false;
      this.State.isTag = 0;
      // this.stopReceiverParty()
    },

    // 控制显示mainWindow的Tag的hover提示
    showTagTooltip(type) {
      if (this.selectOutputType == 'Tag') {
        if (type == 'enter') {
          this.showTag = true;
        } else {
          this.showTag = false;
        }
      }
    },
    changeR(val) {
      this.selectOutput = val;
    },
    setDefault() {
      this.partyInfo.outputSource = '';
      this.partyInfo.outputId = '';
      this.partyInfo.output = '';
      this.selectOutput = '';
      this.mainwindowId = '';
      this.mainwindowType = '';
    },
    sendApplyAll() {
      if (this.selectOutputType != 'Tag') {
        this.$emit('callback', {
          type: 'applyAll'
        });
      } else {
        this.$emit('callback', {
          type: 'applyAll',
          sourceType: 'Tag'
        });
      }
    },
    getOnlineMember() {
      this.axios.get(`/partyline-backend/conference/onlineMembers/${this.partyCode}`).then(res => {
        if (res.data.errorCode === '0x0') {
          const role2List = res.data.result[2] || [];
          const role4List = res.data.result[4] || [];
          let reportList = role2List.concat(role4List);
          // 在speaker列表里面移除anywhere
          reportList = reportList.filter(v => {
            return !v.excludeSpeakerCandidate && v.nickName;
          });
          // 如果当前 host 不是 questioner，speaker，questionerSpeaker 需要加入到列表里面
          if (!this.State.showConferenceLocal) {
            var _this$partyInfo$behav;
            reportList.unshift({
              nickName: this.partyInfo.behavior.nickName,
              rtilCode: this.partyInfo.rtilCode,
              organization: (_this$partyInfo$behav = this.partyInfo.behavior) === null || _this$partyInfo$behav === void 0 ? void 0 : _this$partyInfo$behav.organization
            });
          }
          reportList.forEach(v => {
            v.visible = false;
            v.mainwindowId = v.rtilCode;
          });
          this.outputList = reportList;
        }
      });
    },
    changeSourceItem() {
      if (this.mainwindowType == 'PBP') {
        let btn = false;
        this.mainwindowPBP.forEach(item => {
          if (item.rtilCode) {
            btn = true;
          }
        });
        this.pbpList.forEach(val => {
          this.mainwindowPBP.forEach(item => {
            if (btn && val.position == item.position) {
              this.$set(val, 'rtilCode', item.rtilCode);
            }
          });
        });
        if (btn) {
          this.$message.error(this.$t('kioskHost.pbpErrorPopup'));
        }
      }
    },
    getOutputList(type, visiable, val) {
      // if (!val) return
      if (this.selectOutputType === 'VFB' || this.selectOutputType === 'PP' || this.selectOutputType === 'Tag') {
        // 单独为 Common party mianwindow 添加特殊逻辑
        if (this.selectOutputType === 'PP' && this.$route.name === 'party') {
          this.getAllPpList();
        } else {
          this.getReceiverList(type, '', visiable, val);
        }
      } else if (this.selectOutputType == 'shareScreen') {
        this.outputList = this.shareListCode;
      } else if (this.selectOutputType === 'Broadcaster') {
        let codeList = [];
        const pipLists = [];
        codeList = JSON.parse(JSON.stringify(this.rtilCodeList));
        codeList = codeList.filter(rtilcode => {
          return rtilcode > 0;
        });
        codeList.forEach(val => {
          const type = this.State.deviceTypeMap[val];
          if (this.nickNameInfo[val] && type != 'T' && type != 'R') {
            pipLists.push({
              mainwindowId: val
            });
          }
        });
        this.outputList = pipLists;
      } else if (this.selectOutputType === 'pip' && this.$route.name === 'coordinator') {
        this.getOnlineMember();
      } else {
        this.getParticipantsList();
      }
    },
    loadNextPage() {
      if (this.selectOutputType === 'VFB' && this.receiverListInfo.hasNextPage) {
        this.getReceiverList('getReceiverList', 'loadNextPage');
      }
    },
    getReceiverList(type, loadNextPage, visiable, val) {
      if (type === 'filter') this.cancel.getReceiverList();
      loadNextPage ? this.getReceiverParams.pageNum++ : this.getReceiverParams.pageNum = 1;
      if (visiable) {
        this.getReceiverParams.condition = '';
      } else {
        this.getReceiverParams.condition = val;
      }
      const _this = this;
      const params = this.getReceiverParams;
      params.queryCollaborate = true;
      this.axios.post('/partyline-backend/receiver/v3/page', params, {
        cancelToken: new CancelToken(function executor(c) {
          _this.cancel.getReceiverList = c;
        })
      }).then(res => {
        if (res && res.data.errorCode === '0x0') {
          const result = res.data.result;
          if (this.selectOutputType === 'VFB') {
            this.receiverListInfo = result.cc;
            if (loadNextPage) {
              this.outputList = this.outputList.concat(result.cc.list);
            } else {
              this.outputList = result.cc.list;
            }
          } else {
            const ppList = res.data.result.pps;
            const array = [];
            ppList === null || ppList === void 0 ? void 0 : ppList.forEach(item => {
              item.pageInfo.list.forEach(item1 => {
                array.push({
                  ...item.user,
                  ...item1
                });
              });
            });
            this.outputList = array;
          }
          this.outputList.forEach(val => {
            val.mainwindowId = val.peerId || val.receiverId;
          });
        }
      });
    },
    // common party 有些做功能所以需要获取所有协作的实例
    getAllPpList() {
      const params = {
        pageNum: 1,
        pageSize: 100,
        living: true,
        offline: false,
        online: true,
        queryCollaborate: true
      };
      this.axios.post('/partyline-backend/receiver/v3/page', params).then(res => {
        if (!res) return;
        if (res.data.errorCode === '0x0') {
          const ppList = res.data.result.pps;
          const array = [];
          ppList === null || ppList === void 0 ? void 0 : ppList.forEach(item => {
            item.pageInfo.list.forEach(item1 => {
              array.push({
                ...item.user,
                ...item1
              });
            });
          });
          this.outputList = array;
          this.outputList.forEach(val => {
            val.mainwindowId = val.peerId || val.receiverId;
          });
        }
      });
    },
    getParticipantsList() {
      if (this.$route.name === 'party') {
        this.Url = '/partyline-backend/commonParty/noLogin/getViewRtilCodes';
      } else {
        this.Url = '/partyline-backend/kiosk/noLogin/getViewRtilCodes';
      }
      this.axios.get(this.Url, {
        params: {
          partyCode: this.partyCode
        }
      }).then(res => {
        if (res.data.errorCode == '0x0') {
          if (this.$route.name === 'party') {
            this.outputList = res.data.result.viewPosition.participant.concat(res.data.result.viewPosition.host);
          } else {
            this.outputList = res.data.result.viewPosition.participant;
          }
          const pipLists = [];
          this.outputList.forEach(val => {
            pipLists.push({
              mainwindowId: val
            });
          });
          this.outputList = pipLists;
          this.pipList = JSON.parse(JSON.stringify(this.outputList));
          // 处理 pbp list
          if (!this.pbpList[0].rtilCode && !this.pbpList[1].rtilCode) {
            this.pbpList.forEach(item => {
              item.outputList = pipLists;
            });
          } else if (this.pbpList[0].rtilCode && !this.pbpList[1].rtilCode) {
            this.$set(this.pbpList[0], 'outputList', pipLists);
            this.$set(this.pbpList[1], 'outputList', pipLists.filter(info => {
              return this.pbpList[0].rtilCode != info.mainwindowId;
            }));
          } else if (!this.pbpList[0].rtilCode && !this.pbpList[0].rtilCode) {
            this.$set(this.pbpList[0], 'outputList', pipLists.filter(info => {
              return this.pbpList[1].rtilCode != info.mainwindowId;
            }));
            this.$set(this.pbpList[1], 'outputList', pipLists);
          } else {
            this.$set(this.pbpList[0], 'outputList', pipLists.filter(info => {
              return this.pbpList[1].rtilCode != info.mainwindowId;
            }));
            this.$set(this.pbpList[1], 'outputList', pipLists.filter(info => {
              return this.pbpList[0].rtilCode != info.mainwindowId;
            }));
          }
        }
      });
    },
    async showVfbDialog(item, type) {
      this.$emit('callback', {
        type: 'savePreviewName',
        val: item.name
      });
      if (this.selectOutputType == 'VFB') {
        // 给receiverNickname赋值
        this.UserVfbname = item.name;
        this.sourceVfbType.currentRId = item.mainwindowId;
        this.sourceVfbType.sourceType = 'VFB';
        this.sourceVfbType.params = {
          receiverId: item.mainwindowId // 会存在再点击的时候，change事件在click之后，selectout还未改变值,所以要用item的值
        };

        this.sendReceiverInfo.outputRid = this.partyInfo.status ? this.partyInfo.status.outputId : this.globalMainInfo.outputId; // item.mainwindowId
        this.sendReceiverInfo.outputSourceType = this.partyInfo.status ? this.partyInfo.status.outputSource : this.globalMainInfo.outputSource;
        this.sourceVfbType.show = true;
        this.sourceVfbType.productionId = '';
      }
      if (this.selectOutputType == 'PP') {
        // 先判断是否存在多声道，如果存在则弹窗
        await this.axios.get(`/partyline-backend/receiver/getEncoderSourcesV2/${item.mainwindowId}`).then(res => {
          if (res.data.errorCode == '0x0') {
            const result = res.data.result;
            result.forEach(val => {
              if (val.name == 'PGM') {
                // 给receiverNickname赋值
                this.Username = item.name;
                this.sourceVfbType.currentRId = item.mainwindowId;
                this.sourceVfbType.sourceType = 'PGM';
                this.sourceVfbType.params = {
                  receiverId: item.mainwindowId // 会存在再点击的时候，change事件在click之后，selectout还未改变值,所以要用item的值
                };

                this.sendReceiverInfo.outputRid = this.partyInfo.status ? this.partyInfo.status.outputId : this.partyInfo.outputId;
                this.sendReceiverInfo.outputSourceType = this.partyInfo.status ? this.partyInfo.status.outputSource : this.partyInfo.outputSource;
                this.sourceVfbType.show = true;
                if (item.id) {
                  this.sourceVfbType.productionId = item.id;
                } else {
                  this.outputList.forEach(item => {
                    if (item.receiverId == this.selectOutput) {
                      this.sourceVfbType.productionId = item.id;
                    }
                  });
                }
              }
            });
          }
        });
      }
    },
    updateVfbData(obj) {
      if (obj.operateType == 'stop') {
        this.stopReceiverParty(obj);
      } else if (obj.operateType == 'send') {
        if (this.shareList && JSON.stringify(this.shareList) != '{}' && this.$route.name === 'group') {
          this.$message({
            type: 'warning',
            message: this.$t('addWords.stopShareScreenTip')
          });
          return;
        }
        this.StartReceiverParty(obj);
      }
    },
    async controlOutput() {
      const _this = this;
      if (_this.sendBtnColor == 'gray') return;
      if (_this.selectOutputType === 'shareScreen') {
        _this.shareScreenByMainwindow();
        return;
      }
      if (_this.selectOutputType === 'pip' || _this.selectOutputType == 'PBP' || _this.selectOutputType == 'Tag') {
        if (_this.sendBtnColor == 'red') {
          this.stopReceiverParty();
        } else {
          if (_this.selectOutputType == 'PBP') {
            const rtilCodes = this.pbpList.map(v => v.rtilCode);
            if ([...new Set(rtilCodes)].length < rtilCodes.length) {
              _this.$message.error('Please select two different pips.');
              return;
            }
          }
          _this.StartReceiverParty();
        }
      } else {
        if (_this.sendBtnColor == 'red') {
          // 为了 Gallery view 特殊添加
          if (_this.selectOutputType === 'Broadcaster') {
            _this.$emit('callback', {
              type: 'stopBroadcaster',
              val: this.selectOutput
            });
          } else {
            _this.stopReceiverParty();
          }
        } else {
          // 为了 Gallery view 特殊添加
          if (_this.selectOutputType === 'Broadcaster') {
            _this.$emit('callback', {
              type: 'startBroadcaster',
              val: this.selectOutput,
              nickName: this.nickNameInfo[this.selectOutput]
            });
          }
          if (_this.selectOutputType == 'VFB' || _this.selectOutputType === 'PP') {
            this.showVfbDialog({
              mainwindowId: this.selectOutput
            }, 'sendBtn');
          }
        }
      }
    },
    async stopReceiverParty(obj = {}) {
      let params = {};
      if (this.globalControlId) {
        params = {
          globalControlId: this.globalControlId,
          sourceType: this.changeSourceParams[this.selectOutputType]
        };
      } else {
        params = {
          partyCode: this.partyCode
        };
      }
      if (this.liveLoading) return;
      // 为了 Global Control 添加
      if (JSON.stringify(this.globalMainInfo) != '{}') return;
      this.liveLoading = true;
      const routeName = this.$route.name;
      await this.axios.post(this.requestUrl.stop[routeName], params).then(res => {
        this.liveLoading = false;
        if (res.data.errorCode === '0x0') {
          // this.showSelect = false
          this.$message.success(this.$t('galleryHost.stopSucc'));
          // 用于关闭选择vfb type的弹窗
          obj.callback && obj.callback(obj);
          this.partyInfo.status.outputSource = '';
          this.partyInfo.status.outputId = '';
          this.partyInfo.status.output = '';
        }
      }).catch(() => {
        this.liveLoading = false;
      });
    },
    StartReceiverParty(obj = {}) {
      if ((!this.partyCode || this.sendBtnColor != 'green' && !obj.operateType) && !this.globalControlId) return;
      // 为了 kiosk globalControl 特意加的
      let params = {};
      if (this.globalControlId) {
        params = {
          globalControlId: this.globalControlId,
          sourceType: this.changeSourceParams[this.selectOutputType]
        };
      } else {
        params = {
          partyCode: this.partyCode,
          sourceType: this.changeSourceParams[this.selectOutputType]
        };
      }
      if (this.selectOutputType == 'VFB' || this.selectOutputType == 'PP') {
        params.receiverSource = {
          receiverId: this.selectOutput,
          sourceType: obj.source,
          trackIds: obj.trackIds,
          receiverNickname: this.selectOutputType == 'VFB' ? this.UserVfbname : this.Username
        };
        if (!this.selectOutput) return;
      }
      if (this.selectOutputType == 'pip') {
        params.pipSource = {
          rtilCode: this.selectOutput,
          nickName: this.nickNameInfo[this.selectOutput]
        };
      }
      if (this.selectOutputType == 'PBP') {
        params.pbpInfo = {
          pbpSources: this.pbpList,
          layout: '50%'
        };
      }
      if (this.selectOutputType == 'shareScreen') {
        params.shareMsg = {
          rtilCode: this.selectOutput,
          initiator: this.shareList[this.selectOutput]
        };
      }
      if (this.liveLoading) return;
      this.liveLoading = true;
      const routeName = this.$route.name;
      this.axios.post(this.requestUrl.send[routeName], params).then(res => {
        // this.showSelect = true
        this.liveLoading = false;
        if (res.data.errorCode === '0x0') {
          this.$message.success(this.$t('galleryHost.sendSucc'));
          // 用于关闭选择vfb type的弹窗
          obj.callback && obj.callback(obj);
          this.partyInfo.status.outputSource = params.receiverSource ? params.receiverSource.sourceType : '';
          this.partyInfo.status.outputId = this.selectOutput || obj.currentRId;
        } else if (res.data.errorCode == '82201204') {
          const result = JSON.parse(res.data.errorInfo);
          const array = [];
          result.encoders.forEach(item => {
            const obj = {};
            obj.code = item.code;
            obj.title = item.title ? item.title : new Date(item.createTime).toLocaleDateString() + ' ' + new Date(item.createTime).toLocaleTimeString();
            obj.mode = this.ChannelMode[item.mode] ? this.ChannelMode[item.mode].toLowerCase() : '';
            if (item.loginUser) {
              obj.email = item.loginUser.email;
            }
            obj.outputSource = item.vfbSource;
            obj.realPartyCode = item.realPartyCode;
            obj.rid = this.selectOutput;
            obj.loginUser = item.loginUser;
            obj.globalControlId = item.globalControlId;
            obj.hasStop = false;
            obj.loading = false;
            array.push(obj);
          });
          this.encoderInfo.maxNumber = result.maxEncoderNumber;
          this.encoderInfo.data = array;
          this.encoderInfo.visible = true;
          this.sourceVfbType.show = false;
        }
      }).catch(() => {
        this.liveLoading = false;
      });
    },
    changeMainWindowType() {
      // Tag功能添加
      this.$emit('callback', {
        sourceType: this.selectOutputType
      });
      if (this.selectOutputType == this.mainwindowType) {
        if (this.$route.name === 'group' && this.selectOutputType === 'shareScreen') {
          this.selectOutput = 'Host(me)';
        } else {
          this.selectOutput = this.mainwindowId;
        }
      } else {
        this.selectOutput = '';
        this.outputList = [];
      }
      this.receiverListInfo = {};
      this.getReceiverParams.pageNum = 1;
      this.getOutputList(true);
      Bus.$emit('initMainWindowType', this.selectOutputType);
    },
    async shareScreenByMainwindow() {
      if (this.mainwindowId && this.mainwindowType == 'shareScreen') {
        // 如果host直接分享的mainwindow，则stop需要用户自己点停止按钮取消,取消mainwindow和 stop share
        // 否则取消output回到pip的位置
        const _this = this;
        if (this.currentTypeShare == 'mainWindow') {
          if (_this.shareList[_this.mainwindowId] == _this.partyInfo.rtilCode) {
            _this.$emit('callback', {
              type: 'stopShare',
              id: _this.mainwindowId
            });
            return;
          }
        }
        // 如果存在share的大屏，先取消
        // 如果切换了share，还需要发起setoutput
        if (this.sendBtnColor == 'green' && this.selectOutput) {
          this.StartReceiverParty();
        }
        if (this.sendBtnColor == 'red') {
          this.stopReceiverParty();
        }
        return;
      }
      this.selectOutput && this.StartReceiverParty();
    }
  }
};